import {
    AppsContainerGroup,
    AppsEditMode,
    EditModalDataType,
} from "types/apps-container";

import { faEdit, faEye, faEyeSlash } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type RenderActionsDataType = {
    data: EditModalDataType;
    editMode: AppsEditMode;
    openEditSubgroupModal: any;
    changeGroupVisibility: any;
};

const EditAppsModalActions: React.FC<RenderActionsDataType> = ({
    data,
    editMode,
    openEditSubgroupModal,
    changeGroupVisibility,
}) => {
    return (
        <div className="c-edit-apps-modal__actions ">
            {editMode === "group" ? (
                <>
                    <button
                        onClick={() =>
                            openEditSubgroupModal(data as AppsContainerGroup)
                        }
                        className="c-edit-apps-modal__edit-subgroup-button"
                    >
                        <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                        onClick={() => changeGroupVisibility(data)}
                        className="c-edit-apps-modal__subgroup-visibility-button"
                    >
                        <FontAwesomeIcon
                            icon={data.visible ? faEye : faEyeSlash}
                        />
                    </button>
                </>
            ) : null}
        </div>
    );
};

export default EditAppsModalActions;
